// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 查询某租户全部保证金账户（分页 + 高级搜索） GET /api/v1/hq/tenants/${param0}/deposits */
export async function DepositControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DepositControllerListV1Params,
  options?: { [key: string]: any }
) {
  const { tenantId: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantDepositDtoArray>(
    `/api/v1/hq/tenants/${param0}/deposits`,
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",
        ...queryParams,
      },
      ...(options || {}),
    }
  );
}

/** 缴纳保证金（首次或追加） POST /api/v1/hq/tenants/${param0}/deposits */
export async function DepositControllerPayV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DepositControllerPayV1Params,
  body: MyApi.PayDepositDto,
  options?: { [key: string]: any }
) {
  const { tenantId: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantDepositDto>(
    `/api/v1/hq/tenants/${param0}/deposits`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 扣划保证金 POST /api/v1/hq/tenants/${param0}/deposits/${param1}/deduct */
export async function DepositControllerDeductV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DepositControllerDeductV1Params,
  body: MyApi.DeductDepositDto,
  options?: { [key: string]: any }
) {
  const { tenantId: param0, type: param1, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantDepositDto>(
    `/api/v1/hq/tenants/${param0}/deposits/${param1}/deduct`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 冻结保证金 POST /api/v1/hq/tenants/${param0}/deposits/${param1}/freeze */
export async function DepositControllerFreezeV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DepositControllerFreezeV1Params,
  body: MyApi.FreezeDepositDto,
  options?: { [key: string]: any }
) {
  const { tenantId: param0, type: param1, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantDepositDto>(
    `/api/v1/hq/tenants/${param0}/deposits/${param1}/freeze`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 退还保证金 POST /api/v1/hq/tenants/${param0}/deposits/${param1}/refund */
export async function DepositControllerRefundV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DepositControllerRefundV1Params,
  body: MyApi.RefundDepositDto,
  options?: { [key: string]: any }
) {
  const { tenantId: param0, type: param1, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantDepositDto>(
    `/api/v1/hq/tenants/${param0}/deposits/${param1}/refund`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}
